'use client'

import React from 'react'
import { Section } from '@/components/Section'
import type { Post } from '@/payload-types'
import { PostCard } from '@/components/PostCard'
import { PostCardLarge } from '@/components/PostCardLarge'
type BlogSpotlightClientProps = {
  posts: Post[]
}

export function BlogSpotlightClient({ posts }: BlogSpotlightClientProps) {
  if (!posts || posts.length === 0) {
    return null
  }

  return (
    <Section bgClassName="bg-paper-1" className="pb-[50px]" py={false}>
      <div className="flex flex-col md:flex-row gap-[50px]">
        <div className="flex-7">
          <PostCardLarge post={posts[0]!} card={false} aspectRatio="4/3" showAuthor />
        </div>
        <div className="w-[2px] border border-rock-1" />
        <div className="flex-3 flex flex-col gap-[50px]">
          {posts.slice(1).map((post) => (
            <div key={post.id} className="">
              <PostCard post={post} widthClassName="w-full" card={false} aspectRatio="4/3" />
            </div>
          ))}
        </div>
      </div>
    </Section>
  )
}
